import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './shared-module/services/auth-guard.service';



const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: 'app/home-module/home.module#HomeModule',
  },
  {
    path: 'admin',
    // possible a pathMatch: 'prefix' here?
    // This tells the router to match the redirect route when the remaining URL begins with the redirect route's prefix path
    loadChildren: 'app/admin-module/admin.module#AdminModule',
    canActivate: [AuthGuard],
    // canLoad: [AuthGuard]
    // resolve: { "categories": CategoriesResolver, "tags": TagsResolver }
  },
  {
    path: 'student',
    loadChildren: 'app/student-module/student.module#StudentModule',
    // canActivate: [AuthGuard],
    // resolve: { "categories": CategoriesResolver, "tags": TagsResolver }
  },
  // {
  //   path: 'instructor',
  //   loadChildren: 'app/instructor/instructor.module#InstructorModule',
  //   canActivate: [AuthGuard],
  //   canLoad: [AuthGuard]
  // }
  {
    path: '**',
    redirectTo: '/home',
  }
];



@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
